module.exports = __webpack_public_path__ + "assets/EmptyShoppingCartStat-e8f65c.svg";